var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgFenceUnsafe = function SvgSvgFenceUnsafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 21c-.827 0-1.5-.673-1.5-1.5V18h-3v1.5c0 .827-.673 1.5-1.5 1.5h-3c-.827 0-1.5-.673-1.5-1.5V18H6v1.5c0 .827-.673 1.5-1.5 1.5h-3C.673 21 0 20.327 0 19.5V5.25c0-1.654 1.346-3 3-3s3 1.346 3 3V7.5h3V5.25c0-1.654 1.346-3 3-3s3 1.346 3 3V7.5h3V5.25c0-1.654 1.346-3 3-3s3 1.346 3 3V19.5c0 .827-.673 1.5-1.5 1.5zM21 3.75c-.827 0-1.5.673-1.5 1.5V19.5h3V5.25c0-.827-.673-1.5-1.5-1.5m-9 0c-.827 0-1.5.673-1.5 1.5V19.5h3V5.25c0-.827-.673-1.5-1.5-1.5m-9 0c-.827 0-1.5.673-1.5 1.5V19.5h3V5.25c0-.827-.673-1.5-1.5-1.5M18 16.5V9h-3v7.5zm-9 0V9H6v7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 5h3v2h-3zM17 5h3v2h-3zM21 2h3v20h-3zM13 10h3v2h-3zM15 7h3v2h-3zM15 16h3v2h-3zM17 10h3v2h-3zM13 14h3v2h-3zM17 14h3v2h-3zM13 18h3v3h-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 18h5v3h-5z"
  })));
};
export default SvgSvgFenceUnsafe;